import Products from "../Products/Products";
import React, { useEffect } from "react";
import { getProducts } from "../../Redux/Slices/Products/productsAction";
import { useDispatch, useSelector } from "react-redux";
import NavBar from "../NavBar/NavBar";
import Footer from "../Footer/Footer";

const Refacciones = () => {
    const dispatch = useDispatch();
    const { products } = useSelector((state) => state.products);

    useEffect(() => {
        dispatch(getProducts());
    }, [dispatch]);

    return (
        <div class=" overflow bg-gray-300">
        <NavBar />

        <div class=" p-20 flex justify-center flex-wrap">
        {Object.values(products)
                
                
                .filter(products =>products.subCategory === "Alquiler equipos")
                .map((el) => {
                        
                        return (
                            <div class="">
                            <Products
                                key={el.id}
                                id={el.id}
                                name={el.name}
                                image={el.image}
                                description={el.description}
                                disponible={el.disponible}
                                price={el.price}
                            />
                            </div>
                        );
                    })}
            </div>
          
                <Footer />
            
        </div>
    );
};


export default Refacciones;
